/**
 * Centralized TanStack Query key factory
 */
export const queryKeys = {
  integrations: {
    all: ['integrations'] as const,
    list: () => [...queryKeys.integrations.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.integrations.all, 'detail', id] as const,
  },
} as const;
